export default class ProcessoTipoJulgamento {
    idProcesso: number;
    idMinuta: string;
    tipoJulgamento: TipoJulgamentoEnum;
    idSessao?: string;
    permiteAlteracao: boolean;
}

export enum TipoJulgamentoEnum {
    VIRTUAL = "VIRTUAL",
    PRESENCIAL = "PRESENCIAL"
}
